import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { Drawer } from '../../components/ui/Drawer';
import { CheckIcon, XIcon, MessageSquareIcon } from 'lucide-react';
const queueData = [{
  id: 'REQ-1042',
  supplier: 'Oceanic Harvest Pte Ltd',
  type: 'Bank Detail Change',
  priority: 'High',
  submitted: '2 hours ago',
  sla: 'On Track',
  assigned: 'Unassigned'
}, {
  id: 'REQ-1041',
  supplier: 'Golden Fields Agriculture',
  type: 'Profile Update',
  priority: 'Medium',
  submitted: '1 day ago',
  sla: 'Warning',
  assigned: 'Sarah Lim'
}, {
  id: 'REQ-1038',
  supplier: 'TechServe Asia',
  type: 'New Supplier Activation',
  priority: 'High',
  submitted: '2 days ago',
  sla: 'Overdue',
  assigned: 'Rachel Tan'
}];
export const ReviewQueuesPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('procurement');
  const [selectedReq, setSelectedReq] = useState<any>(null);
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-514">
      <PageHeader title="Review Queues" description="Process pending approvals across functional domains." data-id="element-515" />

      <Card noPadding data-id="element-516">
        <div className="px-6 pt-4 border-b border-border-light overflow-x-auto" data-id="element-517">
          <Tabs tabs={[{
          id: 'procurement',
          label: 'Procurement',
          count: 3
        }, {
          id: 'finance',
          label: 'Finance',
          count: 4
        }, {
          id: 'legal',
          label: 'Legal',
          count: 2
        }, {
          id: 'compliance',
          label: 'Compliance',
          count: 5
        }, {
          id: 'security',
          label: 'Security',
          count: 1
        }, {
          id: 'masterdata',
          label: 'Master Data',
          count: 2
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-518" />
        </div>
        <div className="p-6" data-id="element-519">
          <div className="flex justify-between items-center mb-4" data-id="element-520">
            <h3 className="text-lg font-semibold text-text-primary capitalize" data-id="element-521">
              {activeTab} Queue
            </h3>
            <Button variant="secondary" data-id="element-522">Assign to Me</Button>
          </div>
          <DataTable data={queueData} columns={[{
          header: 'Request ID',
          accessorKey: 'id',
          cell: row => <span className="font-medium text-fpg-navy" data-id="element-524">{row.id}</span>
        }, {
          header: 'Supplier',
          accessorKey: 'supplier'
        }, {
          header: 'Request Type',
          accessorKey: 'type'
        }, {
          header: 'Priority',
          cell: row => <span className={`font-medium ${row.priority === 'High' ? 'text-status-error' : ''}`} data-id="element-525">
                    {row.priority}
                  </span>
        }, {
          header: 'Submitted',
          accessorKey: 'submitted'
        }, {
          header: 'SLA Status',
          cell: row => <span className={`text-sm ${row.sla === 'Overdue' ? 'text-status-error font-bold' : row.sla === 'Warning' ? 'text-status-warning font-bold' : 'text-status-success'}`} data-id="element-526">
                    {row.sla}
                  </span>
        }, {
          header: 'Assigned To',
          accessorKey: 'assigned'
        }]} onRowClick={setSelectedReq} data-id="element-523" />
        </div>
      </Card>

      <Drawer isOpen={!!selectedReq} onClose={() => setSelectedReq(null)} title="Review Request" size="md" footer={<>
            <Button variant="ghost" onClick={() => setSelectedReq(null)} data-id="element-528">
              Cancel
            </Button>
            <Button variant="danger" leftIcon={<XIcon className="w-4 h-4" data-id="element-530" />} data-id="element-529">
              Reject
            </Button>
            <Button variant="primary" leftIcon={<CheckIcon className="w-4 h-4" data-id="element-532" />} data-id="element-531">
              Approve
            </Button>
          </>} data-id="element-527">
        {selectedReq && <div className="space-y-6" data-id="element-533">
            <div className="p-4 bg-surface-secondary rounded-fluent border border-border-light" data-id="element-534">
              <div className="flex justify-between items-start mb-2" data-id="element-535">
                <h3 className="font-bold text-lg" data-id="element-536">{selectedReq.type}</h3>
                <StatusPill status="Pending" data-id="element-537" />
              </div>
              <p className="text-sm text-text-secondary mb-1" data-id="element-538">
                Supplier:{' '}
                <span className="font-medium text-text-primary" data-id="element-539">
                  {selectedReq.supplier}
                </span>
              </p>
              <p className="text-sm text-text-secondary" data-id="element-540">
                Request ID: {selectedReq.id}
              </p>
            </div>

            <div data-id="element-541">
              <h4 className="font-semibold mb-3" data-id="element-542">Request Details</h4>
              <div className="border border-border-light rounded-fluent overflow-hidden" data-id="element-543">
                <table className="w-full text-sm text-left" data-id="element-544">
                  <thead className="bg-surface-secondary border-b border-border-light" data-id="element-545">
                    <tr data-id="element-546">
                      <th className="p-2 font-medium" data-id="element-547">Field</th>
                      <th className="p-2 font-medium" data-id="element-548">Current Value</th>
                      <th className="p-2 font-medium text-fpg-navy" data-id="element-549">
                        Proposed Value
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border-light" data-id="element-550">
                    <tr data-id="element-551">
                      <td className="p-2 text-text-secondary" data-id="element-552">Bank Name</td>
                      <td className="p-2" data-id="element-553">DBS Bank</td>
                      <td className="p-2 font-medium" data-id="element-554">OCBC Bank</td>
                    </tr>
                    <tr data-id="element-555">
                      <td className="p-2 text-text-secondary" data-id="element-556">Account No</td>
                      <td className="p-2" data-id="element-557">****6789</td>
                      <td className="p-2 font-medium" data-id="element-558">****1234</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div data-id="element-559">
              <h4 className="font-semibold mb-3" data-id="element-560">Supporting Documents</h4>
              <div className="p-3 border border-border-light rounded-fluent flex justify-between items-center" data-id="element-561">
                <span className="text-sm font-medium text-fpg-navy cursor-pointer hover:underline" data-id="element-562">
                  Bank_Statement_2026.pdf
                </span>
                <span className="text-xs text-text-secondary" data-id="element-563">
                  Uploaded 2 hours ago
                </span>
              </div>
            </div>

            <div data-id="element-564">
              <label className="block text-sm font-medium text-text-primary mb-1" data-id="element-565">
                Reviewer Comments (Optional)
              </label>
              <textarea className="w-full p-2 border border-border-default rounded-fluent text-sm" rows={3} placeholder="Add notes for audit trail..." data-id="element-566"></textarea>
            </div>
          </div>}
      </Drawer>
    </div>;
};